import { useImperativeHandle } from 'react'
import { ActionCardData, updateActionCard, UpdaterDto } from '@playbooks/action-cards-utils/src'

import { useAppContext } from '../contexts/AppContext'
import { SlidesData } from '../types'

export interface ActionCardsElement {
  getValue: () => ActionCardData | null
  getSlides: () => SlidesData
  getSlidesData: () => {
    canProceed: boolean
    slides: SlidesData
  }
  highlightElementIds: (ids: number[]) => void
  partialUpdate: (data: UpdaterDto) => ActionCardData
}

export default function useActionCardsApiRegister(
  ref: React.Ref<ActionCardsElement | null> | undefined,
  slides: SlidesData,
) {
  const { data, setActionCards, prevActionCardsDataRef, setHighlightedIds, highlightElementsServiceRef } =
    useAppContext()

  useImperativeHandle(ref, (): ActionCardsElement => {
    return {
      getValue: () => data ?? null,
      getSlides: () => slides,
      getSlidesData: () => {
        return {
          canProceed: highlightElementsServiceRef.current.getIds().length === 0,
          slides,
        }
      },
      highlightElementIds: (ids: number[]) => {
        const additionalIdsToHighlight = highlightElementsServiceRef.current.getIds()
        setHighlightedIds(Array.from(new Set([...ids, ...additionalIdsToHighlight])))
      },
      partialUpdate: partOfData => {
        const updatedData = JSON.parse(JSON.stringify(updateActionCard(data, partOfData))) as ActionCardData

        prevActionCardsDataRef.current = updatedData

        setActionCards(updatedData)

        return updatedData
      },
    }
  }, [data, slides, highlightElementsServiceRef, setHighlightedIds, prevActionCardsDataRef, setActionCards])
}
